import React, { useState, useEffect, useRef } from "react";
import { setCookie, getCookie } from "../../ReusableFunctions/cookieHandlers";
import Header from "../../components/header/Header";
import Banner from "../../components/banner/Banner";
import { AddRecentlyPlayed, GetDataFromURL } from "../../service/service";
import { ColorRing } from "react-loader-spinner";
import Footer from "../../components/footer/Footer";
import NotFound from "../notfoundPage/NotFound";
import UserCategory from "../userCategoyPages/UserCategory";
import {
  FacebookIcon,
  FacebookShareButton,
  TwitterShareButton,
  WhatsappIcon,
  WhatsappShareButton,
  XIcon,
} from "react-share";
import { Helmet, HelmetProvider } from "react-helmet-async";
import CustomAudioPlayer from "../../ReuseableComponents/CustomPlayer";
import CustomVideoPlayer from "../../ReuseableComponents/CustomVideoPlayer";
import PDFViewer from "../../ReuseableComponents/PDFViewer";
import { addAttributes } from "../../ReusableFunctions/handleHtmlAttributes";
import { Link } from "react-router-dom";
import EmbedClass from "./EmbedClass";
import { DocumentIcon } from "../../assets/icon-file";
import {
  LoadingOverlay,
  LoadingDocFallback,
} from "../../ReuseableComponents/LoadingDocument";
import isValidMediaUrl from "../../ReusableFunctions/validateMediaUrl";
import { parseDeepLinkTimestamp } from "../../ReusableFunctions/deepLinkTimestamp";
import SimilarClasses from "../../ReuseableComponents/rag/SimilarClasses";

function SearchClasses({ uniqueName }) {
  // Feature flag to control normalized vs legacy block rendering
  const USE_NORMALIZED_BLOCKS = true; // Toggle this flag to switch between rendering modes

  const [loading, setLoading] = useState(false);
  const [data, setData] = useState(null);
  const [showShare, setShowShare] = useState(false);
  const [type, setType] = useState("");
  // const { uniqueName } = useParams();
  const [title, setTitle] = useState(
    "Inside Chassidus | Audio Classes | Chassidus for Everyone",
  );
  const [viewDocuments, setViewDocuments] = useState({});
  const [loadingDocument, setLoadingDocument] = useState(false);
  const [iframeStyle, setIframeStyle] = useState({});
  const [widths, setWidths] = useState({
    screenWidth: window.innerWidth,
    fallbackHeight: window.innerWidth > 550 ? "44px" : "72px",
  });
  const [renderIframeFallback, setRenderIframeFallback] = useState({});
  const [urlTimestamp, setUrlTimestamp] = useState({});
  const iframeRefs = useRef({});
  const isSafari = /^((?!chrome|android).)*safari/i.test(navigator.userAgent);
  const { screenWidth, fallbackHeight } = widths;

  useEffect(() => {
    // Scroll to the top when the component mounts
    window.scrollTo(0, 0);

    // Optionally, you can also add a listener for navigation changes
    const handleScrollToTop = () => {
      window.scrollTo(0, 0);
    };

    // Attach the listener to the "beforeunload" event
    window.addEventListener("beforeunload", handleScrollToTop);
    // Clean up the listener when the component unmounts
    return () => {
      window.removeEventListener("beforeunload", handleScrollToTop);
    };
  }, [uniqueName]);
  useEffect(() => {
    if (uniqueName !== "") {
      const data = {
        node: uniqueName,
      };
      setLoading(true);
      GetDataFromURL(data).then((result) => {
        setLoading(false);
        if (result.status) {
          setType(result.type);
          setData(result.data);
          if (result.data) {
            setTitle(
              `${result.data?.title ?? result.data?.name} | Inside Chassidus`,
            );
          }
        }
      });
    }
  }, [uniqueName]);

  useEffect(() => {
    if (type === "class") {
      // Update these widths on load
      const updateWidths = () => {
        setWidths({
          screenWidth: window.innerWidth,
          fallbackHeight: window.innerWidth > 550 ? "44px" : "72px",
        });
      };
      updateWidths();
      window.addEventListener("resize", updateWidths);
      return () => window.removeEventListener("resize", updateWidths);
    }
  }, [type]);

  useEffect(() => {
    if (type === "class" || data) {
      // Determine which blocks to process based on feature flag and data availability
      const useNormalized =
        USE_NORMALIZED_BLOCKS &&
        Array.isArray(data?.normalized_block) &&
        data.normalized_block.length > 0;

      if (useNormalized) {
        // Process normalized blocks
        data.normalized_block.forEach((normalizedBlock) => {
          const { block_type, block, id } = normalizedBlock;

          // Checking for cookies for video and audio urls and updating url with timestamp if found
          if (block_type === "video" || block_type === "audio") {
            const url = block.video_src || block.audio_src;
            const savedTime = getCookie(url);
            if (savedTime) {
              const timestampedUrl = `${url}#t=${savedTime}`;
              setUrlTimestamp((prev) => ({ ...prev, [url]: timestampedUrl }));
            }
          }

          // Check for media content to render embed button
          if (
            (block_type === "video" &&
              isValidMediaUrl(block.video_src, "video")) ||
            (block_type === "audio" &&
              isValidMediaUrl(block.audio_src, "audio")) ||
            (block_type === "html" &&
              block.html_block &&
              /<(audio|video)[^>]+src=["']([^"']+)["']/.test(block.html_block))
          ) {
            setShowShare(true);
          }

          // Initialize document block rendering
          if (block_type === "file" && (block.file_url || block.download_url)) {
            setIframeStyle((prev) => ({
              ...prev,
              [id]: { height: "500px", classes: "" },
            }));
            setRenderIframeFallback((prev) => ({
              ...prev,
              [id]: false,
            }));
            if (screenWidth < 640) {
              setViewDocuments((prev) => ({ ...prev, [id]: false }));
            }
          }
        });
      } else if (data?.block) {
        // Process legacy blocks (existing logic)
        for (let i = 0; i < data.block.length; i++) {
          // Checks if either video or audio is present in the block to render embed button
          if (
            (data.block[i].type === "Video" &&
              isValidMediaUrl(data.block[i].url, "video")) ||
            (data.block[i].type === "Audio" &&
              isValidMediaUrl(data.block[i].url, "audio")) ||
            (data.block[i].type === "Custom HTML" &&
              /<(audio|video)[^>]+src=["']([^"']+)["']/.test(
                data.block[i].html,
              ))
          ) {
            setShowShare(true);
          }
          // Initialize how each document block will render
          const blockType = data.block[i].type;
          const id = data.block[i].id;
          if (blockType === "Documents") {
            setIframeStyle((prev) => ({
              ...prev,
              [id]: { height: "500px", classes: "" },
            }));
            setRenderIframeFallback((prev) => ({
              ...prev,
              [id]: false,
            }));
            if (screenWidth < 640) {
              setViewDocuments((prev) => ({ ...prev, [id]: false }));
            }
          }
        }
      }

      // To determine the height of the Iframe element, we check whether the default pdf rendered or the fallback. Smaller screens and Safari use pdf viewer for pdfs and for now the fallback for other docs.
      if (screenWidth > 639) {
        handleRenderingDoc();
      }
    }
  }, [data, USE_NORMALIZED_BLOCKS, screenWidth]);

  // Deep-link seek: when arriving via a RAG search result (?t=<seconds>&src=<mediaUrl>),
  // seed the player's seek fragment for that media URL, overriding any resume cookie.
  useEffect(() => {
    if (!data) return;
    const deepLink = parseDeepLinkTimestamp(window.location.search);
    if (!deepLink) return;
    setUrlTimestamp((prev) => ({
      ...prev,
      [deepLink.src]: `${deepLink.src}#t=${deepLink.seconds}`,
    }));
  }, [data]);

  const handleRenderingDoc = () => {
    setLoadingDocument(true);
    const timeout = setTimeout(() => {
      for (let i = 0; i < data?.block?.length; i++) {
        const currentData = data?.block[i];
        if (currentData.type === "Documents") {
          if (
            (currentData.url.split(".").pop() === "pdf" && !isSafari) ||
            currentData.url.split(".").pop() === "docx"
          ) {
            handleIsDocRendered({
              id: currentData.id,
              docType: currentData.url.split(".").pop(),
            });
          }
        }
      }
      setLoadingDocument(false);
    }, 1000);
    return () => clearTimeout(timeout);
  };

  const handleIsDocRendered = ({ id, docType }) => {
    // Null contentDocument indicates the Doc rendered
    const isDocRendered = !iframeRefs.current[id]?.contentDocument;
    if (
      !isDocRendered ||
      (!isDocRendered &&
        !iframeRefs.current[id]?.contentDocument?.body?.innerHTML)
    ) {
      setIframeStyle((prev) => ({
        ...prev,
        [id]: { height: prev[id]?.height || "500px", classes: "hidden" },
      }));
      setRenderIframeFallback((prev) => ({
        ...prev,
        [id]: true,
      }));
    } else {
      setIframeStyle((prev) => ({
        ...prev,
        [id]: {
          height: prev[id]?.height || "500px",
          classes:
            docType === "pdf"
              ? "border-b-[2px] border-[#333639]"
              : "border-y-[3px] border-[#313131]",
        },
      }));
    }
  };

  const handleViewDocuments = ({ id, docType }) => {
    setViewDocuments((prev) => ({
      ...prev,
      [id]: !prev[id],
    }));
    // Currently the Iframe element renders only for screens > 639. So currently this code is esentially disabled since larger screens don't run this function. If we solve the issue with the word docs not consistently displaying (though the logs show they rendered), we can enable this code for its intended purpose - to check whether the doc rendered and set the style accordingly or show the fallback.
    if (docType === "docx" && screenWidth > 639) {
      setLoadingDocument(true);
      setTimeout(() => {
        // The condition guarantees the function won't run when closing the Doc render.
        if (iframeStyle[id]?.classes === "hidden") {
          handleIsDocRendered({ id, docType });
        }
        setLoadingDocument(false);
      }, 1000);
    }
    if (viewDocuments[id]) {
      setRenderIframeFallback((prev) => ({
        ...prev,
        [id]: false,
      }));
      // Reset the Iframe style for docx when closing the document. Currently, no reset would be needed as explained in the long comment above.
      setIframeStyle((prev) => ({
        ...prev,
        [id]: {
          height: prev[id]?.height || "500px",
          classes: docType === "docx" ? "" : iframeStyle[id]?.classes || "",
        },
      }));
    }
  };

  const formatDate = (inputDate) => {
    const date = new Date(inputDate);
    const options = { year: "numeric", month: "long", day: "numeric" };
    const formattedDate = date.toLocaleDateString("en-US", options);
    return formattedDate;
  };
  const downloadFile = (fileUrl) => {
    const a = document.createElement("a");
    a.href = fileUrl;
    a.target = "_blank"; // Opens the link in a new tab
    a.click();
  };
  const shareUrl = window.location.href;

  const [lastPlayedMedia, setLastPlayedMedia] = useState({});
  const sendRecentPlayData = (classId, blockId, type) => {
    // Make an API call to add to recent play with class ID, block ID, and type
    const payload = {
      id: classId,
      block_id: blockId,
      type: type,
    };

    // Simulating the API call - Replace this with your actual API call logic
    // console.log('Adding to recent play:', payload);
    AddRecentlyPlayed(payload)
      .then()
      .catch((error) => {
        console.log(error);
      });

    setLastPlayedMedia(payload);
  };

  const handleRecentlyPlayed = (blockId, blockType) => {
    const classId = data?.id; // Assuming the class ID is available in the data

    if (
      classId &&
      blockId &&
      blockType &&
      localStorage.getItem("accessToken") !== null
    ) {
      if (
        !(
          lastPlayedMedia.id === classId &&
          lastPlayedMedia.block_id === blockId &&
          lastPlayedMedia.type === blockType
        )
      ) {
        // If current media is different from the last played, trigger API call
        sendRecentPlayData(classId, blockId, blockType);
      }
    }
  };

  // Helper function to render legacy blocks (encapsulates existing logic)
  const renderLegacyBlock = (obj) => {
    if (obj.type === "Audio" && isValidMediaUrl(obj.url, "audio") === false)
      return null;
    if (obj.type === "Video" && isValidMediaUrl(obj.url, "video") === false)
      return null;

    const processedHtml =
      obj.type === "Custom HTML" ? addAttributes(obj.html) : null;
    return (
      <>
        {obj.type === "Paragraph" && (
          <div className="text-primaryDark text-lg font-semibold">
            {obj.description}
          </div>
        )}
        {obj.type === "Video" && (
          <div>
            <CustomVideoPlayer
              videoUrl={{ url: obj.url, urlTimestamp: urlTimestamp[obj.url] }}
              logRecentlyPlayed={() => handleRecentlyPlayed(obj.id, "Video")}
            />
          </div>
        )}
        {obj.type === "Audio" && (
          <div>
            <CustomAudioPlayer
              audioUrl={{ url: obj.url, urlTimestamp: urlTimestamp[obj.url] }}
              logRecentlyPlayed={() => handleRecentlyPlayed(obj.id, "Audio")}
            />
          </div>
        )}
        {obj.type === "Documents" && (
          <>
            {screenWidth < 640 && (
              <div>
                <button
                  onClick={() =>
                    handleViewDocuments({
                      id: obj.id,
                      docType: obj.url.split(".").pop(),
                    })
                  }
                  type="button"
                  className={`mx-auto w-[75%] text-blue-700 hover:text-white border border-blue-700 hover:bg-blue-800 focus:ring-4 focus:outline-none focus:ring-blue-300 font-medium rounded-lg text-md px-5 py-1.5 flex gap-2 items-center justify-center ${
                    viewDocuments[obj.id] ? "mb-3" : ""
                  }`}
                >
                  <DocumentIcon classes="w-6 h-6" />
                  <span className="w-32">
                    {viewDocuments[obj.id] ? "Hide Document" : "View Document"}
                  </span>
                </button>
              </div>
            )}
            {
              // Only for PDFs using pdf viewer...
              // Any browser when screen is < 640
              // Any size screen Safari
              obj.url.split(".").pop() === "pdf" &&
                ((screenWidth < 640 && viewDocuments[obj.id] === true) ||
                  (isSafari && screenWidth > 639)) && (
                  <PDFViewer
                    id={obj.id}
                    pdfUrl={obj.url}
                    downloadFile={downloadFile}
                  />
                )
            }
            {
              // For any documents using the default PDF...
              // Non PDFs in all browsers
              // PDFs for browsers other than Safari when screen is > 639
              ((isSafari &&
                obj.url.split(".").pop() !== "pdf" &&
                (screenWidth > 639 ||
                  (screenWidth < 640 && viewDocuments[obj.id] === true))) ||
                (!isSafari &&
                  ((screenWidth < 640 &&
                    obj.url.split(".").pop() !== "pdf" &&
                    viewDocuments[obj.id] === true) ||
                    screenWidth > 639))) && (
                <div id={obj.id} className="relative">
                  {loadingDocument && (
                    <LoadingOverlay
                      height="[500px]"
                      text="Loading Document..."
                      textSize="text-sm"
                      classes="absolute top-0"
                      textClasses={`${fallbackHeight === "72px" ? "my-5" : ""}`}
                    />
                  )}
                  {screenWidth > 639 && (
                    <iframe
                      title="document"
                      className={iframeStyle[obj.id]?.classes}
                      ref={(el) => (iframeRefs.current[obj.id] = el)}
                      src={
                        obj.url.split(".").pop() === "docx"
                          ? `https://docs.google.com/gview?url=${obj.url}&embedded=true`
                          : obj.url
                      }
                      type={
                        obj.url.split(".").pop() === "pdf"
                          ? "application/pdf"
                          : obj.url.split(".").pop() === "docx"
                            ? "text/html"
                            : ""
                      }
                      width="100%"
                      height={iframeStyle[obj.id]?.height}
                    />
                  )}
                  {(renderIframeFallback[obj.id] || screenWidth < 640) && (
                    <LoadingDocFallback
                      id={obj.id}
                      url={obj.url}
                      downloadFile={downloadFile}
                    />
                  )}
                </div>
              )
            }
          </>
        )}
        {obj.type === "Images" && (
          <>
            <div className="flex justify-center rounded-lg">
              <img src={obj.url} alt="class" />
            </div>
          </>
        )}
        {obj.type === "Custom HTML" && (
          <>
            <div
              style={{ overflowWrap: "break-word" }}
              dangerouslySetInnerHTML={{
                __html: processedHtml,
              }}
            />
          </>
        )}
      </>
    );
  };

  // Helper functions for normalized block rendering
  const renderFileBlock = (block, id) => {
    const url = block.file_url || block.download_url;
    if (!url) return null;

    return (
      <>
        {screenWidth < 640 && (
          <div>
            <button
              onClick={() =>
                handleViewDocuments({
                  id: id,
                  docType: url.split(".").pop(),
                })
              }
              type="button"
              className={`mx-auto w-[75%] text-blue-700 hover:text-white border border-blue-700 hover:bg-blue-800 focus:ring-4 focus:outline-none focus:ring-blue-300 font-medium rounded-lg text-md px-5 py-1.5 flex gap-2 items-center justify-center ${
                viewDocuments[id] ? "mb-3" : ""
              }`}
            >
              <DocumentIcon classes="w-6 h-6" />
              <span className="w-32">
                {viewDocuments[id] ? "Hide Document" : "View Document"}
              </span>
            </button>
          </div>
        )}
        {
          // Only for PDFs using pdf viewer...
          // Any browser when screen is < 640
          // Any size screen Safari
          url.split(".").pop() === "pdf" &&
            ((screenWidth < 640 && viewDocuments[id] === true) ||
              (isSafari && screenWidth > 639)) && (
              <PDFViewer id={id} pdfUrl={url} downloadFile={downloadFile} />
            )
        }
        {
          // For any documents using the default PDF...
          // Non PDFs in all browsers
          // PDFs for browsers other than Safari when screen is > 639
          ((isSafari &&
            url.split(".").pop() !== "pdf" &&
            (screenWidth > 639 ||
              (screenWidth < 640 && viewDocuments[id] === true))) ||
            (!isSafari &&
              ((screenWidth < 640 &&
                url.split(".").pop() !== "pdf" &&
                viewDocuments[id] === true) ||
                screenWidth > 639))) && (
            <div id={id} className="relative">
              {loadingDocument && (
                <LoadingOverlay
                  height="[500px]"
                  text="Loading Document..."
                  textSize="text-sm"
                  classes="absolute top-0"
                  textClasses={`${fallbackHeight === "72px" ? "my-5" : ""}`}
                />
              )}
              {screenWidth > 639 && (
                <iframe
                  title="document"
                  className={iframeStyle[id]?.classes}
                  ref={(el) => (iframeRefs.current[id] = el)}
                  src={
                    url.split(".").pop() === "docx"
                      ? `https://docs.google.com/gview?url=${url}&embedded=true`
                      : url
                  }
                  type={
                    url.split(".").pop() === "pdf"
                      ? "application/pdf"
                      : url.split(".").pop() === "docx"
                        ? "text/html"
                        : ""
                  }
                  width="100%"
                  height={iframeStyle[id]?.height}
                />
              )}
              {(renderIframeFallback[id] || screenWidth < 640) && (
                <LoadingDocFallback
                  id={id}
                  url={url}
                  downloadFile={downloadFile}
                />
              )}
            </div>
          )
        }
      </>
    );
  };

  const renderParagraphBlock = (block, id) => {
    const content = block.paragraph_text || block.paragraph_html;
    if (!content) return null;

    return (
      <div className="text-primaryDark text-lg font-semibold">
        {block.paragraph_text ? (
          content
        ) : (
          <div dangerouslySetInnerHTML={{ __html: content }} />
        )}
      </div>
    );
  };

  const renderAudioBlock = (block, id) => {
    const audioUrl = block.audio_src;

    if (isValidMediaUrl(audioUrl, "audio") === false) {
      return (
        <div className="text-xl text-red-500">Audio currently unavailable.</div>
      );
    }
    return (
      <div>
        <CustomAudioPlayer
          audioUrl={{
            url: audioUrl,
            urlTimestamp: urlTimestamp[audioUrl],
            streamUrl: block.audio_stream_url,
          }}
          logRecentlyPlayed={() => handleRecentlyPlayed(id, "Audio")}
        />
      </div>
    );
  };

  const renderVideoBlock = (block, id) => {
    const videoUrl = block.video_src;
    if (isValidMediaUrl(videoUrl, "video") === false) {
      return (
        <div className="text-xl text-red-500">Video currently unavailable.</div>
      );
    }

    return (
      <div>
        <CustomVideoPlayer
          videoUrl={{
            url: videoUrl,
            urlTimestamp: urlTimestamp[videoUrl],
            streamUrl: block.video_stream_url,
          }}
          logRecentlyPlayed={() => handleRecentlyPlayed(id, "Video")}
        />
      </div>
    );
  };

  const renderHtmlBlock = (block, id) => {
    const htmlContent = block.html_block;
    if (!htmlContent) return null;

    // Use the same processing as legacy Custom HTML
    const processedHtml = addAttributes(htmlContent);

    return (
      <div
        style={{ overflowWrap: "break-word" }}
        dangerouslySetInnerHTML={{
          __html: processedHtml,
        }}
      />
    );
  };

  // Main normalized block renderer
  const renderNormalizedBlock = (normalized) => {
    const { block_type, block, id } = normalized;

    switch (block_type) {
      case "file":
        return renderFileBlock(block, id);
      case "paragraph":
        return renderParagraphBlock(block, id);
      case "audio":
        return renderAudioBlock(block, id);
      case "video":
        return renderVideoBlock(block, id);
      case "html":
        return renderHtmlBlock(block, id);
      default:
        console.warn(`Unknown normalized block type: ${block_type}`);
        return null;
    }
  };

  return (
    <HelmetProvider>
      <Helmet>
        <script src="https://cdn.jsdelivr.net/npm/js-cookie@2/src/js.cookie.min.js"></script>
        <script type="text/javascript">{setCookie() + getCookie()}</script>
      </Helmet>
      <div className="flex flex-col min-h-screen">
        <Header />
        <Banner
          title={data?.title ?? data?.name}
          description={data?.description}
        />
        <Helmet>
          <title>{title}</title>
          {/* <meta name="description" content='classes' /> */}
        </Helmet>
        {loading ? (
          <div className="flex justify-center grow min-h-[200px]">
            <ColorRing
              visible={true}
              height="80"
              width="80"
              ariaLabel="blocks-loading"
              wrapperStyle={{}}
              wrapperClass="blocks-wrapper"
              colors={["#D2D6DC", "#D2D6DC", "#D2D6DC", "#D2D6DC", "#D2D6DC"]}
            />
          </div>
        ) : (
          <div className="grow">
            {type === "class" && (
              <>
                {data ? (
                  <section className="px-2 xs:px-5 pt-6 pb-[38px] md:pt-8 md:pb-[100px]">
                    <div className="2xl:max-w-2xl xl:max-w-xl lg:max-w-lg md:max-w-md sm:max-w-sm mx-auto text-primaryDark">
                      <div className="text-primaryDark text-sm font-semibold opacity-50 mb-3">
                        {data?.created_at &&
                          `Posted : ${formatDate(
                            data?.is_publish_date ?? data?.created_at,
                          )}`}
                      </div>
                      {(() => {
                        // Determine if we should use normalized blocks or legacy blocks
                        const useNormalized =
                          USE_NORMALIZED_BLOCKS &&
                          Array.isArray(data?.normalized_block) &&
                          data.normalized_block.length > 0;

                        if (useNormalized) {
                          // Use normalized blocks - sort by position and render
                          const sortedBlocks = [...data.normalized_block].sort(
                            (a, b) => a.position - b.position,
                          );

                          return sortedBlocks.map((normalized) => (
                            <div
                              key={`${normalized.id}-${normalized.block_type}`}
                              className="mb-10"
                            >
                              {renderNormalizedBlock(normalized)}
                            </div>
                          ));
                        } else {
                          // Use legacy blocks - existing behavior
                          return data?.block?.map((obj) => (
                            <div key={obj.id} className="mb-10">
                              {renderLegacyBlock(obj)}
                            </div>
                          ));
                        }
                      })()}

                      {data?.is_page !== 1 && (
                        <>
                          {data?.tags?.length > 0 && (
                            <div className="flex flex-wrap gap-3 mt-6 mb-4">
                              {data?.tags?.map((tag) => (
                                <Link
                                  key={tag.id}
                                  to={`tag/${tag?.slug}`}
                                  className="py-2 px-6 bg-primaryDark rounded-md text-base text-whiteGrey"
                                >
                                  {tag.name}
                                </Link>
                              ))}
                            </div>
                          )}

                          {showShare && (
                            <>
                              <div className="font-bold text-xl">
                                Share this class!
                              </div>
                              <div className="flex items-center gap-x-[27px] mt-3">
                                <WhatsappShareButton
                                  url={shareUrl}
                                  separator=":: "
                                  className="Demo__some-network__share-button"
                                >
                                  <WhatsappIcon size={32} round />
                                </WhatsappShareButton>
                                <FacebookShareButton
                                  url={shareUrl}
                                  className="Demo__some-network__share-button"
                                >
                                  <FacebookIcon size={32} round />
                                </FacebookShareButton>

                                <TwitterShareButton
                                  url={shareUrl}
                                  className="Demo__some-network__share-button"
                                >
                                  <XIcon size={32} round />
                                </TwitterShareButton>
                                <EmbedClass classData={data} />
                              </div>
                            </>
                          )}
                        </>
                      )}

                      {data?.is_page !== 1 && data?.id && (
                        <SimilarClasses classId={data.id} />
                      )}
                    </div>
                  </section>
                ) : (
                  <NotFound />
                )}
              </>
            )}
            {type === "category" && <UserCategory data={data} />}
            {type === null && <NotFound />}
          </div>
        )}
        <Footer />
      </div>
    </HelmetProvider>
  );
}

export default SearchClasses;
